import { Button, Container } from '@playcanvas/pcui';
import { Events } from '../events';
import { localize } from './localization';
import { Tooltips } from './tooltips';
import measureSvg from './svg/measure.svg';

const createSvg = (svgString: string) => {
    const decodedStr = decodeURIComponent(svgString.substring('data:image/svg+xml,'.length));
    return new DOMParser().parseFromString(decodedStr, 'image/svg+xml').documentElement;
};

class MeasureButton extends Container {
    constructor(events: Events, tooltips: Tooltips, args = {}) {
        args = {
            ...args,
            id: 'measure-button-container'
        };

        super(args);

        this.dom.addEventListener('pointerdown', (event) => {
            event.stopPropagation();
        });

        const measureButton = new Button({
            class: 'measure-button'
        });

        measureButton.dom.appendChild(createSvg(measureSvg));

        this.append(measureButton);

        tooltips.register(measureButton, localize('tooltip.measure-distance'), 'right');

        // Handle measure button click
        measureButton.on('click', () => {
            events.fire('tool.measure');
        });

        // Handle tool activation state
        events.on('tool.activated', (toolName: string) => {
            measureButton.class[toolName === 'measure' ? 'add' : 'remove']('active');
        });
    }
}

export { MeasureButton };
